import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Nav } from './components/site/Nav';
import { Footer } from './components/site/Footer';
import { Home } from './pages/Home';
import { Methodology } from './pages/Methodology';
import { Company } from './pages/Company';
import { applyDocumentMetadata } from './utils/metadata';

/** Routed pages should open at the top, not at the previous scroll position. */
function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
    applyDocumentMetadata();
  }, [pathname]);
  return null;
}
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="31ctbbg5tvg3d">
      <div className="w-full bg-bone font-sans text-ink" data-id="element-1" data-mp="2wka18t6cn33b">
        <ScrollToTop data-id="element-2" data-mp="2wip6b2g4hi4x" />
        <Nav data-id="element-3" data-mp="2wi5lndz38fn7" />
        <main data-id="element-4" data-mp="28u5y0mx2p5cu">
          <Routes data-id="element-5" data-mp="28tw3qn4zwc1c">
            <Route path="/" element={<Home data-id="element-7" data-mp="28sl48zil1qg1" />} data-id="element-6" data-mp="28te4dhn1dhp7" />
            <Route path="/methodology" element={<Methodology data-id="element-9" data-mp="23w4e5zrtp20b" />} data-id="element-8" data-mp="28s30zixi6bym" />
            <Route path="/company" element={<Company data-id="element-11" data-mp="23ti5txx3yih1" />} data-id="element-10" data-mp="23ut9zyugts8o" />
          </Routes>
        </main>
        <Footer data-id="element-12" data-mp="3ij61y35c994p" />
      </div>
    </BrowserRouter>;
}